import { render, staticRenderFns } from "./Product-Purchases.vue?vue&type=template&id=6d6ac8d9&scoped=true&"
import script from "./Product-Purchases.vue?vue&type=script&lang=js&"
export * from "./Product-Purchases.vue?vue&type=script&lang=js&"
import style0 from "./Product-Purchases.vue?vue&type=style&index=0&id=6d6ac8d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ac8d9",
  null
  
)

export default component.exports